import React from "react";
import IndividualAccountDetails from "./IndividualAccountDetails";
import NonIndividualAccountDetails from "./NonIndividualAccountDetails";
import OverviewTable from "./OverviewTable";

function AccountsOverview({activeTab}) {
      
    return (
        <div className="overview-section">
            <label className="overview-title">Accounts Overview</label>
            <div className="wrap-overview-card">
                <IndividualAccountDetails />
                <NonIndividualAccountDetails />
            </div>
            <OverviewTable activeTab={activeTab}/>
        </div>
    );
}

export default AccountsOverview;
